<div [ngStyle]="{'margin-bottom' : IsNeedNewLine ? '0px' : '-5px'}" *ngIf="itemMandatory">
  <div class="row">
    <div [ngClass]="IsLargeText || IsNeedNewLine ? 'col-12' : 'col-4'">
      <div [ngStyle]="{'text-align' : IsLargeText || IsNeedNewLine ? 'left' : 'right'}">
        <app-label [Text]="Title == '' ? localService.languageContent.common.language_container : Title"
          [IsAllMandatory]="IsAllMandatory" [IsPartiallyMandatory]="IsPartiallyMandatory"
          [IsNeedNewLine]="IsNeedNewLine">
        </app-label>
        <button *ngIf="IsLargeText" class="button_icon button_icon_color" style="float: right;
      margin-top: -10px !important;"
          [ngStyle]="{'transform' : isShowOtherLanguages ? 'rotate(-90deg)' : 'rotate(90deg)'}"
          (click)="onShowHideOtherLanguages()"
          title="{{ isShowOtherLanguages ? localService.languageContent.common.hide_other_langu : localService.languageContent.common.show_other_langu}}">arrow_forward_ios</button>
        <button *ngIf="IsLargeText" class="button_icon button_icon_color" style="float: right;
          margin-top: -8px !important;"
          title="{{isLockAutoSenseTranslate ? localService.languageContent.common.unlock_auto_sense_translate : localService.languageContent.common.lock_auto_sense_translate}}"
          (click)="isLockAutoSenseTranslate = !isLockAutoSenseTranslate">
          {{isLockAutoSenseTranslate ? 'lock' : 'lock_open'}}</button>
      </div>
      <div *ngIf="IsLargeText">
        <textarea maxlength="{{MaxLength}}" id="{{id+'_m'}}" [(ngModel)]="itemMandatory.v3"
          placeholder="{{Title == '' ? localService.languageContent.common.language_container : Title}} ({{getLanguageValue(3,itemMandatory.v1)}})"
          (keydown.enter)="focusToNextId()" (keydown.Tab)="focusToNextId()"
          title="{{Title == '' ? localService.languageContent.common.language_container : Title}} ({{getLanguageValue(3,itemMandatory.v1)}}) (Maximum Characters : {{MaxLength}})"
          [ngClass]="itemMandatory.v3 ? localService.getLanguageCode(itemMandatory.v1) : ''"
          (blur)="onCheckEnglishLanguage()" (input)="onClearOtherLanguage()"></textarea>

        <div *ngIf="IsCustomLanguageRequired">
          <app-label [Text]="localService.languageContent.common.cust_lang" [IsNeedNewLine]="true"></app-label>
          <textarea maxlength="{{MaxLength}}" id="{{id+'_mc'}}" [(ngModel)]="itemCustom.v3"
            placeholder="{{localService.languageContent.common.cust_lang}}" (keydown.enter)="focusToNextId()"
            (keydown.Tab)="focusToNextId()"
            title="{{localService.languageContent.common.cust_lang}} (Maximum Characters : {{MaxLength}})"
            [ngClass]="itemCustom.v3 ? localService.getLanguageCode(itemCustom.v1) : ''"></textarea>
        </div>
      </div>
      <div *ngIf="IsNeedNewLine && !IsLargeText" style="margin-top: -15px;">
        <input *ngIf="itemMandatory" (keydown.enter)="focusToNextId()" (keydown.Tab)="focusToNextId()"
          style="width:calc(100% - 80px);top: 15px;    position: relative;" autocomplete="off" type="text"
          maxlength="{{MaxLength}}" id="{{id+'_m'}}" [(ngModel)]="itemMandatory.v3"
          placeholder="{{Title == '' ? localService.languageContent.common.language_container : Title}} ({{getLanguageValue(3,itemMandatory.v1)}})"
          title="{{Title == '' ? localService.languageContent.common.language_container : Title}} ({{getLanguageValue(3,itemMandatory.v1)}}) (Maximum Characters : {{MaxLength}})"
          [ngClass]="itemMandatory.v3 ? localService.getLanguageCode(itemMandatory.v1) : ''"
          (blur)="onCheckEnglishLanguage()" (input)="onClearOtherLanguage()" />
        <button class="button_icon button_icon_color" style="float: right;
    margin-top: 5px !important;" [ngStyle]="{'transform' : isShowOtherLanguages ? 'rotate(-90deg)' : 'rotate(90deg)'}"
          (click)="onShowHideOtherLanguages()"
          title="{{ isShowOtherLanguages ? localService.languageContent.common.hide_other_langu : localService.languageContent.common.show_other_langu}}">arrow_forward_ios</button>
        <button class="button_icon button_icon_color" style="float: right;
            margin-top: 5px !important;"
          title="{{isLockAutoSenseTranslate ? localService.languageContent.common.unlock_auto_sense_translate : localService.languageContent.common.lock_auto_sense_translate}}"
          (click)="isLockAutoSenseTranslate = !isLockAutoSenseTranslate">
          {{isLockAutoSenseTranslate ? 'lock' : 'lock_open'}}</button>
        <div *ngIf="IsCustomLanguageRequired">
          <app-label [Text]="localService.languageContent.common.cust_lang" [IsNeedNewLine]="true"></app-label>
          <input *ngIf="itemCustom" (keydown.enter)="focusToNextId()" (keydown.Tab)="focusToNextId()"
            style="width:calc(100% - 40px); position: relative;" autocomplete="off" type="text"
            maxlength="{{MaxLength}}" id="{{id+'_mc'}}" [(ngModel)]="itemCustom.v3"
            placeholder="{{localService.languageContent.common.cust_lang}}"
            title="{{localService.languageContent.common.cust_lang}} (Maximum Characters : {{MaxLength}})"
            [ngClass]="itemCustom.v3 ? localService.getLanguageCode(itemCustom.v1) : ''" />
        </div>
      </div>
    </div>
    <div class="col-8" *ngIf="!(IsLargeText || IsNeedNewLine)">
      <input *ngIf="itemMandatory" (keydown.enter)="focusToNextId()" (keydown.Tab)="focusToNextId()"
        style="width:calc(100% - 80px); position: relative;" autocomplete="off" type="text" maxlength="{{MaxLength}}"
        id="{{id+'_m'}}" [(ngModel)]="itemMandatory.v3"
        placeholder="{{Title == '' ? localService.languageContent.common.language_container : Title}} ({{getLanguageValue(3,itemMandatory.v1)}})"
        title="{{Title == '' ? localService.languageContent.common.language_container : Title}} ({{getLanguageValue(3,itemMandatory.v1)}}) (Maximum Characters : {{MaxLength}})"
        [ngClass]="itemMandatory.v3 ? localService.getLanguageCode(itemMandatory.v1) : ''" />
      <button class="button_icon button_icon_color" style="float: right;"
        [ngStyle]="{'transform' : isShowOtherLanguages ? 'rotate(-90deg)' : 'rotate(90deg)'}"
        (click)="onShowHideOtherLanguages()"
        title="{{ isShowOtherLanguages ? localService.languageContent.common.hide_other_langu : localService.languageContent.common.show_other_langu}}">arrow_forward_ios</button>
      <button class="button_icon button_icon_color" style="float: right;
          margin-top: 5px !important;"
        title="{{isLockAutoSenseTranslate ? localService.languageContent.common.unlock_auto_sense_translate : localService.languageContent.common.lock_auto_sense_translate}}"
        (click)="isLockAutoSenseTranslate = !isLockAutoSenseTranslate">
        {{isLockAutoSenseTranslate ? 'lock' : 'lock_open'}}</button>
      <div *ngIf="IsCustomLanguageRequired">
        <app-label [Text]="localService.languageContent.common.cust_lang" [IsNeedNewLine]="true"></app-label>
        <input *ngIf="itemCustom" (keydown.enter)="focusToNextId()" (keydown.Tab)="focusToNextId()"
          style="width:calc(100% - 40px); position: relative;" autocomplete="off" type="text" maxlength="{{MaxLength}}"
          id="{{id+'_mc'}}" [(ngModel)]="itemCustom.v3" placeholder="{{localService.languageContent.common.cust_lang}}"
          title="{{localService.languageContent.common.cust_lang}} (Maximum Characters : {{MaxLength}})"
          [ngClass]="itemCustom.v3 ? localService.getLanguageCode(itemCustom.v1) : ''" />
      </div>
    </div>
  </div>
  <div *ngIf="isShowOtherLanguages" class="box" style="background-color: aliceblue;">
    <div style="text-align:right ;">
      <label style="font-weight: normal; margin-right: 15px;" *ngIf="IsShowTransliterate">
        <input type="checkbox" [(ngModel)]="isOnlyTransliterate" (change)="onSetTranliteration()" />
        <span class="normal_color">{{localService.languageContent.common.isOnlyTransliterate}}</span>
      </label>

      <button class="button_icon" style="color: orangered !important;opacity: 0.8;top:-3px;" (click)="onClear()"
        *ngIf="isShowClear" title="{{localService.languageContent.common.reset}}">cancel</button>
      <button class="button_icon button_icon_color" style="margin-right: 5px;" [disabled]="!isEnableAutoTranslation()"
        (click)="onAutoTranslate()">g_translate</button>
      <button class="button_icon button_icon_color" style="margin-right: 5px;" *ngIf="isModeChangeAllowed"
        (click)="onAction(1)" title="{{localService.languageContent.common.large_text_mode}}">expand</button>
    </div>
    <div class="row" *ngIf="languageContents && languageContents.length > 0">
      <div *ngFor="let item of languageContents; index as i">
        <div class="row" *ngIf="isShowLanguage(item.v1)">
          <div *ngIf="!IsLargeText" class="col-3 label_i">{{item.v2}}</div>
          <div *ngIf="!IsLargeText" class="col-9 {{getLanguageValue(2,item.v1)}}">
            <input autocomplete="off" type="text" maxlength="{{MaxLength}}" id="{{id+'_'+(i+1)}}"
              [readonly]="item.isReadonly" [(ngModel)]="item.v3" placeholder="{{getLanguageValue(3,item.v1)}}"
              title="{{getLanguageValue(3,item.v1)}} (Maximum Characters : {{MaxLength}})"
              (keydown.enter)="onFocus(i+1)" (blur)="onCheckEnglishLanguage()" />
          </div>
          <div *ngIf="IsLargeText" class="label_i label_large">{{item.v2}}</div>
          <div *ngIf="IsLargeText" class="{{getLanguageValue(2,item.v1)}}">
            <textarea maxlength="{{MaxLength}}" [(ngModel)]="item.v3" id="{{id+'_'+(i+1)}}" [readonly]="item.isReadonly"
              placeholder="{{getLanguageValue(3,item.v1)}}"
              title="{{getLanguageValue(3,item.v1)}} (Maximum Characters : {{MaxLength}})"
              (keydown.enter)="onFocus(i+1)" (blur)="onCheckEnglishLanguage()"></textarea>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>